import { CreditDocumentUploadResponse, ICreditDocumentUploadRepository } from "@/core/repositories/credit/ICreditDocumentUpload.repository";
import { PrivateHttp } from "@/infrastructure/adapters/http";
import { ApiEndpoints } from "@/infrastructure/services/config";
import { ContentType } from "@ir/core/http";

export class CreditDocumentUploadRepository implements ICreditDocumentUploadRepository {
  async uploadDocument(file: File): Promise<CreditDocumentUploadResponse> {
    const formData = new FormData();
    formData.append("file", file);

    return await new PrivateHttp({
      headers: {
        "Content-Type": ContentType.MULTIPART,
      },
    }).post<CreditDocumentUploadResponse>(ApiEndpoints.UPLOAD_CREDIT_DOCUMENT, formData);
  }
}
